const SaladsMass=[
    // {
    //     id:1,
    //     title:"Салат з куркою та ананасом 250г",
    //     isNew: true,
    //     price:"219 грн",
    //     src:require('../img/salchikananas.png'),
    //     text:"лист салату, помідор чері, куряче філе, ананас, фета, оливкова олія, гірчиця по-французьки",
    // },
    {
        id:2,
        title:"Теплий салат 250г",
        isNew: true,
        price:"250 грн",
        src:require('../img/teplsal.png'),
        text:"куряче філе, печериці, огірок, болгарський перець, помідор, соєвий соус, майонез, гірчиця по-французьки, кунжут",
    allergy: `🥚яйце, 🌱соя, 🌰 кунжут,🌶️гірчиця,🍄‍🟫гриби`
    },
    {
        id:3,
        title:"Салат з морепродуктами 300г",
        isNew: true,
        price:"330 грн",
        src:require('../img/salatsmorem.png'),
        text:"мідії, кальмар, тигрові креветки, помідор, огірок, болгарський перець, кунжут, оливкова олія, гірчиця по-французьки, бальзамічний крем",
        allergy: `🦪мідії,🦑кальмар,🦐тигрові креветки, 🌰кунжут, 🌶️гірчиця`
    },
    // {
    //     id:4,
    //     title:"Аля Цезар з тунцем 250г",
    //     isNew: true,
    //     price:"305 грн",
    //     src:require('../img/salatstuncom.png'),
    //     text:"мікс салату, рукола, помідор черрі, авокадо, перепелині яйця, тунець",
    // },






    // {
    //     id:5,
    //     title:"Салат зі свининою 350г",
    //     price:"229 грн",
    //     src:require('../img/salatsvin.png'),
    //     text:"Мікс салату, помідор черрі, свинина, перепелині яйця, морква по-корейськи",
    // },
    // {
    //     id:6,
    //     title:"Салат з хамоном 250г",
    //     price:"280 грн",
    //     src:require('../img/salatproshuto.png'),
    //     text:"Мікс салату, помідор черрі, заправка салатна, хамон, пармезан, яйця перепелячі, крем бальзамік",
    // },
    {
        id:7,
        title:"A-ля «Цезар» 250г",
        price:"285 грн",
        src: require('../img/cezar.webp'),
        text:"куряче філе, бекон, помідор черрі, мікс-салат, пармезан, соус «Цезар», сухарики, перепелине яйце",
            allergy: `🥛молоко(пармезан),🥚яйце, 🌾глютен(сухарики),🌶️гірчиця`
    },
    {
        id:8,
        title:"Салат з куркою і грибами 250г",
        price:"240 грн",
        src:require('../img/chiken-mush.webp'),
        text:"куряче філе, печериці, помідор, лист салату, кунжут, заправка: медово-гірчична, соєвий соус",
     allergy: `🌰кунжут, 🌱соя,🍯мед, 🌶️гірчиця, 🍄‍🟫гриби `
    },
    {
        id:9,
        title:"A-ля «Грецький» 250г",
        price:"205 грн",
        src:require('../img/greece.webp'),
        text:"огірки, помідори, перець болгарський, фета, кунжут, мікс-салат, маслини, оливкова олія, цибуля Ялта, соус соєвий",
    allergy: `🥛молоко(фета), 🌱соя,🌰кунжут `
    },
    {
        id:10,
        title:"Салат з кальмаром та креветкою 250г",
        price:"330 грн",
        src:require('../img/krevetki-kalmar.webp'),
        text:"лист салату, салат айсберг, креветка, кальмари, помідор, огірок, болгарський перець, часник, заправка літня, сир пармезан, лимон",
    allergy: `🦑кальмар,🦐креветки,🥛молоко(пармезан),🍋цитрус,🌱соя,🌶️гірчиця `
    },
    // {
    //     id:11,
    //     title:"Салат з пряним лососсем 250г",
    //     price:"310 грн",
    //     src:require('../img/redfish.webp'),
    //     text:"пряний лосось, мікс-салат, помідор, сир пармезан, заправка літня, перепелине яйце, авокадо, лимон",
    // },
    // {
    //     id:12,
    //     title:"Салат з телятиною 250г",
    //     price:"255 грн",
    //     src:require('../img/caw.webp'),
    //     text:"лист салату, салат айсберг, телятина, помідор, огірок, болгарський перець, заправка салатна, рукола, кунжут",
    // },
    {
        id:13,
        title:"Салат з тигровими креветками 250г",
        price:"310 грн",
        src:require('../img/tigersal.webp'),
        text:"тигрова кереветка, мікс-салат, помідор, кунжут, олія оливкова, мед, лимон, авокадо",
    allergy: `🦐креветки , 🌱соя, 🌶️гірчиця, 🍋цитрус  `
    },
]

export default SaladsMass;